import tools from '../scripts/tools';
import vars from '../scripts/variables';

require('../style/components/navigation/async.scss');
require('../scripts/ssa_autocomplete');

require('velocity-animate');
const PerfectScrollbar = require('../scripts/perfectScrollbar.js');

const Navigation = function () {
    const _d = document;
    const _w = window;
    const _this = this;
    const $_w = $(_w);
    let currentScroll = $_w.scrollTop();
    _this.headerScrollOffsetDown = 200;
    _this.headerScrollOffsetUp = 200;
    _this.headerScrollSpeed = 250;
    _this.maxHeight = _w.innerHeight * 0.8;
    _this.padding = {
        top: 0,
        bottom: 42 + 24 + 42 + 24 + 13,
        left: 115,
        right: 115
    };

    _this.animationSpeed = 250;
    _this.mouseMoveDelay = 180;

    _this.mobileMenuOpen = false;
    _this.mobileMenuLevel=0;
    _this.$html = $('html');
    _this.$headerContainer = $('.header-container');
    _this.$header = $('#header');
    _this.$mainMenu = $('#main-menu');
    _this.$mobileMenu = $('#mobile-menu');
    _this.$menuContent = _this.$mainMenu.find('.menu-content').first();
    _this.$mobileExtra = '';
    _this.$loginDropDown = $('#signin-dropdown');
    _this.$searchInput = $('#search_query_block');
    _this.$searchInputMobile = $('#search_input_mobile');

    _this.headerHeight = _this.$headerContainer.outerHeight();
    _this.isMobile = tools.getMobileOperatingSystem() !== 'unknown';


    _this.mobileOutSpeedRange = [0.25, 1];
    _this.mobileInSpeedRange = [20, 1];

    if (_this.isMobile) {
        _this.$headerContainer.css({
            transition: '0.25s'
        });
    }


    _this.init = function () {

        // $(_d.body).on('mouseover.kn', '#main-menu .sf-menu > .category', _this.hoverMenu);
        // $(_d.body).on('mouseleave.kn', '#main-menu', _this.closeNavigation);
        // $(_d.body).on('mousemove.kn', _this.onMouseMove);
        _d.addEventListener('mousemove', _this.onMouseMove, {
            passive: true
        });
        $(_d.body).on('klipnavigation.switch', _this.onSwitch);
        $(_d.body).on('klipnavigation.close', _this.onClose);
        $(_d.body).on('klipsearch.beforeshow', _this.beforeSearchResults);

        // $(_w).on('klipscroll', _this.onScroll);
        $(_w).on('scroll.kn', _this.onScroll);
        $(_d.body).on('click.kn tap.kn', _this.onClick);

        $(_w).on('resize.kn', _this._responsive).trigger('resize.kn');
        _this.navigationOpen = false;



        $('.mobile-search').on('click tap touchend', () => {
            import(/* webpackChunkName: "search" */'./search').then(({ default: Search }) => {
                if (typeof this.search === 'undefined') {
                    this.search = new Search(this);
                }
            });
        });
        _this.$searchInput.on('click tap touchend', () => {
            import(/* webpackChunkName: "search" */'./search').then(({ default: Search }) => {
                if (typeof this.search === 'undefined') {
                    this.search = new Search(this);
                }
            });
        });
         _this.$searchInputMobile.on('click tap touchend', () => {
            import(/* webpackChunkName: "search" */'./search').then(({ default: Search }) => {
                if (typeof this.search === 'undefined') {
                    this.search = new Search(this);
                }
            });
        });

        // requestAnimationFrame(_this.animationFrame);
        _this.setHeightMobile();
        window.addEventListener('resize', () => {
            _this.setHeightMobile();
        });
        var wrapperSocial1=$('#footer .wrapper.social .social-icons').clone();
        $('.mobilenavbar-footer-block .mobilenavbar-footer-social .social-icon').append(wrapperSocial1);
        _this.$mobileExtra = _this.$mobileMenu.find('.mobile-extra-menu').first().clone();


        $(_d).on('touchend', '.overlay', e => {
            if (_this.mobileMenuOpen) {
                e.stopPropagation();
                _this.closeMobileMenu();
            }
        });

        $(_d).on('click', '.languages-block-top-main', () => {
            import(/* webpackChunkName: "deliveryCountry", webpackPreload: true */'./deliveryCountry').then(({ default: init }) => init());
        });
    };


    // --------------------------------- EVENTS -------------------------------------
    _this.setHeightMobile = function () {
        let vh = window.innerHeight * 0.01;
        $('#mobile-menu #slide-out').css('min-height',window.innerHeight+'px');
        $('#mobile-menu #slide-out #slide-out-innerx').css('min-height',window.innerHeight+'px');
    }

    _this.animationFrame = function () {
        const st = $_w.scrollTop();
        if (st !== currentScroll && !_this.$html.hasClass('scroll-locked')) {
            $_w.trigger('klipscroll', [st]);
            currentScroll = st;
        }
        // _this.animateHeaderScroll();
        requestAnimationFrame(_this.animationFrame);
    };

    _this.onMouseMove = function (e) {


        clearTimeout(_this.mouseMoveDelayTimeout);
        _this.mouseMoveDelayTimeout = setTimeout(() => {

            var $target = $(e.target);

                if (_this._wWidth >= 1365) {
                    //cart popup open
                    if ($target.is('#mini-cart') || $target.closest('#mini-cart').length == 1) {
                        $('.cart-header-popup').css('display', 'block');

                        if (!$('.cart-popup-head-text').length) {
                            _this.loadCartProductBlock();
                        }
                    }

                    //cart popup close                
                    if ($target.closest('#mini-cart').length !== 1 && $target.closest('.header-popup').length != 1) {
                        $('.cart-header-popup').css('display', 'none');
                    }
                }  
                
                //favorite open     
                if ($target.is('#head-favorite') || $target.closest('#head-favorite').length == 1) {
                    $('.favorite-popup').css('display', 'block');

                    if ($('.loading-user-favorite-block').length && !$('.favorite-popup h4').length) {
                        _this.loadFavoriteBlock();
                    }

                }                
                //favorite close                
                if ($target.closest('#head-favorite').length !== 1 && $target.closest('.header-popup').length != 1) {
                    $('.favorite-popup').css('display', 'none');
                }    
                
                if (_this._wWidth >= 1365) {
                    if ($target.is('#signin-link') || $target.closest('#signin-link').length == 1) {
                        e.preventDefault();
                        _this.toggleLoginDropDown();
                        return;
                    }
                    if ($target.closest('#signin-dropdown').length !== 1 && _this.loginDropOpen) {
                        e.preventDefault();
                        _this.closeLoginDropDown();
                        return;
                    }
                }

            if (_this._wWidth > 991) {

                if (_this.navigationOpen && !_this.transitioning) {
                    if ($target.closest('#main-menu').length === 0) {
                        _this.closeNavigation();
                        return;
                    }
                }


                if ($target.closest('.nav-level-0').length === 1) {
                    var $menu = $target.closest('.nav-level-0');
                    var $content = $menu.find('.menu-item-wrap').first();

                    if (!$content.is('.open') && $content.length > 0) {
                        if (!_this.navigationOpen) {
                            _this.openNavigation($content);
                        } else {
                            _this.switchNavigation($content);
                        }
                        $(document.body).trigger('klipnavigation.switch', [$menu, $content]);
                        return;
                    }
                }
            }

            
        }, _this.mouseMoveDelay);
    };

    _this.onClick = function (e) {
        if (typeof _this.clickEventType === 'undefined') {
            _this.clickEventType = e.type;
        }
        if (e.type != _this.clickEventType) {
            return;
        }

        const $target = $(e.target);

        // uzdaro mobile menu jei paspaudzia ne ant jo arba close ikona

        if ($target.closest('#mobile-menu').length !== 1 || $target.hasClass('close-mm') || $target.hasClass('overlay')) {
            if (_this.mobileMenuOpen) {

                e.stopPropagation();
                _this.closeMobileMenu();
                return;
            }
        }

        // Hamburger

            if ($target.is('#header .hamburger')) {

                setTimeout(() => {
                    _this.toggleMobileMenu();
                }, 150);

                return false;
            }

        // uzdaro mobile level 0 meniu

        if ($target.is('.sub-heading')) {

            e.preventDefault();
                //_this.mobileCloseLevel0();
                _this.mobileCloseLevelAll();
            return;
        }

        // Atidaro mobile paieska

        if ($target.closest('.mobile-search').length === 1) {
            _this.openMobileSeach();
            return;
        }

        // Uzdaro mobile paieska
        if (($target.is('.custom-search-form') || $target.is('#search_block_left')) && _this._wWidth <= 991 || $target.is('.mobile-close-search')) {
            $('#search_query_block').blur();
            _this.hideMobileSearch();
            return;
        }

        // Atidaro paskyros drop dropdown
        if ($target.is('#signin-link') || $target.closest('#signin-link').length == 1) {
            e.preventDefault();
            _this.toggleLoginDropDown();
            return;
        }

        // uzdarom login drop jei paspaude ne ant jo
        if ($target.closest('#signin-dropdown').length !== 1 && _this.loginDropOpen) {
            e.preventDefault();
            _this.closeLoginDropDown();
            return;
        }


        if ($target.is('.category.has-children:not(.nav-level-2)') && _this._wWidth <= 991) {
            e.preventDefault();
            const m = /nav-level-(\d)/g.exec($target[0].className);
            _this[`mobileToggleLevel${m[1]}`]($target);
            return;
        }

        if ($target.parent().is('.category.has-children:not(.nav-level-2)') && _this._wWidth <= 991) {
            e.preventDefault();
            const $parent = $target.parent();
            const m = /nav-level-(\d)/g.exec($parent[0].className);
            //_this[`mobileToggleLevel${m[1]}`]($parent);
            _this.mobileToggleLevelAll($parent);
        }

    };

    _this.responsive = function () {

        if (_this._wWidth > 991) {
            _this.moveMenuToDesktop();
            _this.closeAll(true);

            if (typeof _this.$activeBar !== 'undefined') {
                const $ab = _this.$activeBar;
                $ab.css({
                    opacity: 0
                });
            }
        }
        else {
            _this.moveMenuToMobile();
            _this.closeAll(true);
        }

        _this.headerHeight = _this.$headerContainer.outerHeight();
    };

    _this.onScroll = function (e, scrollTop) {
        
       if($('.mobile-search-open').length || _this._wWidth < 992){
                 return true;
            }

      //  _this.positionHeader(scrollTop);

        if (typeof _this.$searchResultsWrapper !== 'undefined' && _this.$searchResultsWrapper.is(':visible') && _this._wWidth > 992) {
            _this.positionSearchResult();
        }
    };


    _this.beforeSearchResults = () => {
        _this.positionSearchResult();
    };


    // ---------------------------------------- DESKTOP ---------------------------------------


    _this.openNavigation = function ($container) {

        $container.css({
            display: 'block',
        });
        $container.css('opacity', 0);
        $container.addClass('open');

        _this.transitionNavigation($container);
        _this.navigationOpen = true;
        _this.$lastOpen = $container;
    };


    _this.transitionNavigation = function ($container, additional = 0) {
        if (typeof _this.$transitioningElement !== 'undefined') {
            _this.$transitioningElement.velocity('stop', true);
        }

        _this.transitioning = true;

        $container.css('height', 'auto');
        _this.$transitioningElement = $container.velocity({
            opacity: 1,
        }, {
            duration: _this.animationSpeed,
            complete() {
                _this.transitioning = false;
            }
        });
    };


    _this.closeNavigation = function (quick = false) {
        const $container = _this.$mainMenu.find('.sf-menu > .category > .menu-item-wrap').filter(function () {
            return $(this).is(':visible');
        });

        if ($container.length == 0) {
            return;
        }

        const closingHeight = _this.$headerContainer.outerHeight(true) + _this.$headerContainer.offset().top - $container.offset().top;

        if (!quick) {

            if (typeof _this.$transitioningElement !== 'undefined') {
                _this.$transitioningElement.velocity('stop');
            }

            _this.transitioning = true;

            _this.$transitioningElement = $container.velocity({
                'opacity': 0,
            }, {
                duration: _this.animationSpeed,
                complete() {
                    $container.css('display', 'none');
                    _this.navigationOpen = false;
                    _this.transitioning = false;
                    $(_d.body).trigger('klipnavigation.close', [$container]);
                    $container.removeClass('open');
                }
            });
        }
        else {
            $container.css({
                height: closingHeight,
                display: 'none'
            }).removeClass('open');
            _this.navigationOpen = false;
            _this.transitioning = false;
            $(_d.body).trigger('klipnavigation.close', [$container]);
        }

    };

    _this.switchNavigation = function ($container) {
        _this.$mainMenu.find('.sf-menu > .category').each(function () {
            $(this).find('.menu-item-wrap:visible').first().css({
                display: 'none',
                height: 0
            })
                .removeClass('open');
        });
        $container.css({
            display: 'block',
            height: _this.$lastOpen.data().maxHeight + _this.padding.bottom
        });

        $container.addClass('open');

        _this.transitionNavigation($container);
        _this.$lastOpen = $container;
        _this.navigationOpen = true;
    };


    _this.setupHeights = function (element = false) {
        (element.closest('.parent') || _this.$mainMenu.find('.parent'))
            .each(function () {
                const $menu = $(this);
                if (_this._wWidth == $menu.data('_wWith')) {
                    return true;
                }
                $menu.data('_wWith', _this._wWidth);
                const $contentInner = $menu.find('.menu-item-inner-wrap').first();
                const $content = $menu.find('.menu-item-wrap').first();
                const $level2Children = $contentInner.find('.nav-level-2.has-children > .menu-item-wrap');
                const $level1Children = $contentInner.find('.nav-level-1');

                if (!$content.length) {
                    return true;
                }

                $content.css({
                    display: 'block'
                });



                const closingHeight = _this.$headerContainer.outerHeight(true) - $content.offset().top;
                $content.css({
                    display: '',
                    height: closingHeight
                })
                    .data({
                        closingHeight,
                    });

             //   _this.positionLevel1Items(element);
            });

    };


    _this.positionLevel1Items = function (element = false) {
        const $level1Children = (element || _this.$menuContent).find('.nav-level-1');
        $level1Children.each(function () {
            const $l1 = $(this);

            $l1.css({
                height: $l1.data().height,
                width: $l1.data().width,
                left: $l1.data().position.x,
                top: $l1.data().position.y,
                position: 'absolute'
            });
        });
    };


    _this.onSwitch = function (e, $menu) {
        if (typeof _this.$activeBar === 'undefined') {
            _this.$activeBar = $('<span class="active-bar"></span>');
            _this.$mainMenu.append(_this.$activeBar);
        }
        const $ab = _this.$activeBar;

        $ab.css({
            width: $menu.innerWidth(),
            left: $menu.position().left,
            opacity: 1
        });

    };


    _this.onClose = function () {
        if (typeof _this.$activeBar !== 'undefined') {
            const $ab = _this.$activeBar;
            $ab.css({
                opacity: 0
            });
        }
    };


    // ------------------------------------ MOBILUS MENIU -----------------------------------------


    _this.toggleMobileMenu = function () {
        if (_this.mobileMenuOpen) {
            _this.closeMobileMenu();
        }
        else {
            _this.openMobileMenu();
        }
    };


    _this.openMobileMenu = function () {
        _this.mobileMenuOpen = true;
        _this.$mobileMenu
            .children('#slide-out')
            .velocity('stop')
            .velocity({
                left: '0%'
            }, {
                duration: _this.animationSpeed+150,
                complete() {
                    $('body').addClass('mobile-menu-open');
                    $("#slide-out-innerx").scrollTop(0);
                }
            });
            $('#mobile-header .sf-menu').css({
                'height':'',
                'overflow': ''
            });
        $('#mobile-menu .close-mm')
            .show()
            .velocity('stop', true)
            .velocity({
                'left': '290px',
            }, {
                duration: _this.animationSpeed +150
            });
        $('.overlay')
            .css('opacity', 0)
            .show()
            .velocity('stop', true)
            .velocity({
                opacity: 0.5
            }, {
                duration: _this.animationSpeed * 0.5
            });
    };

    _this.closeMobileMenu = function (quick = false) {

        _this.mobileMenuOpen = false;
        $('#mobile-header .sf-menu').css({
            'height': '',
            'overflow': ''
        });
        const $overlay = $('.overlay');
        if (!quick) {
            _this.$mobileMenu
                .children('#slide-out')
                .velocity({
                    left: '-105%'
                }, {
                    duartion: _this.animationSpeed,
                    complete() {
                        $('body').removeClass('mobile-menu-open');
                        $('#slide-out-innerx').css({
                            left: ''
                        });
                    }
                });
            $('#mobile-menu .close-mm')
                .velocity({
                    'left': '-55px',
                }, {
                    duration: _this.animationSpeed,
                    complete: function () {
                        $('#mobile-menu .close-mm').hide();
                    }
                });
            $overlay
                .velocity('stop', true)
                .velocity({
                    opacity: 0
                }, {
                    duration: _this.animationSpeed * 0.5,
                    complete() {
                        $overlay.hide();
                        if (_this._wWidth <= 992) {
                            _this.mobileCloseLevelAll();
                        }
                    }
                });
        }
        else {
            $('body').removeClass('mobile-menu-open');
            _this.$mobileMenu
                .children('#slide-out')
                .css({
                    left: '-105%'
                });
            $('#mobile-menu .close-mm').css({'left':'-55px', 'display':'none'});
            $('#slide-out-inner').css({
                'left': ''
            });

            $overlay.hide();
        }


    };
    _this.mobileOpenLevelAll = function ($trigger) {

        var m = /nav-level-(\d)/g.exec($trigger[0].className);
        var level=parseInt(m[1]);
        _this.mobileMenuLevel=level;
        var $menu = $($trigger).find('.menu-item-wrap').first();


        $menu.find('.sub-menu-banner-right').hide();
        $menu.find('.nav-level-1-custom').hide();
        $menu.find('.sub-menu-ul-left-content').removeClass('sub-menu-ul-left');


        var $innerWrap = $menu.find('.menu-item-inner-wrap').first();

        var $subHeading = $innerWrap.find('.sub-heading');
        var $extra = $innerWrap.find('.mobile-extra-menu');
        var $parentLink = $innerWrap.find('.parent--link');



        if ($extra.length == 0) {
            $extra = _this.$mobileExtra.clone();
            $innerWrap.append($extra);

        }
        // Jei nera sukuriam sub head
        if ($subHeading.length == 0) {
            $subHeading = $('<span class="sub-heading"></span>').html($trigger.find('.sub-title').first().html());
            $innerWrap.prepend($subHeading);
        }
        // Jei nera sukuriam duoroda i tevine
        if ($parentLink.length == 0) {
            let $a = $menu.closest('.nav-level-' + m[1]).find('a').first();
            $innerWrap.find('ul').first().prepend(
                $('<li class="parent--link category child nav-level-'+(parseInt(m[1])+1)+'"></li>')
                    .append(
                        $('<a></a>').attr({
                            'href': $a.attr('href'),
                            'title': $a.attr('title')
                        })
                            .html(SHOW_ALL)
                    )
            );
        }

        $('.nav-level-'+m[1]).each(function () {
            $(this).find('.menu-item-wrap').first().css({
                'display': ''
            });
        });
        $menu.css({
            'display': 'block',
            'opacity':1,
        });

        $('#slide-out-inner')
            .velocity('stop', true)
            .velocity({
                //'left': '-100%'
                'left': ((level+1)*(-100))+'%'
            }, {
                duration: _this.animationSpeed,
                complete: function () {
                    $trigger.data().level_0_open = true;
                    if (level==0) {
                        $('#mobile-header .sf-menu').css({
                            'height':0,
                            'overflow': 'hidden'

                        });
                        $('.slide-out-inner .mobile-extra-menu').css('height',0);

                    }
                    if(level==1) {
                        $('#mobile-header .nav-level-1').css('height',0);

                    }

                }
            });
    };

    _this.mobileCloseLevelAll = function () {
        var level=_this.mobileMenuLevel;
        if (level==1) {
            $('#mobile-header .nav-level-1').css('height','');
            $('.slide-out-inner .mobile-extra-menu').css('height','');
        }
        if (level==0) {
                $('#mobile-header .sf-menu').css({
                    'height':'',
                    'overflow': ''
                });
        }

        $('.nav-level-'+level).each(function () {
            var $this = $(this);
            var $wrapper = $this.find('.menu-item-wrap').first();
            if ($wrapper.is(':visible')) {

                $('#slide-out-inner')
                    .velocity('stop')
                    .velocity({
                        'left': ((level)*(-100))+'%'
                    }, {
                        duration: _this.animationSpeed,
                        complete: function () {
                            $wrapper.first()
                                .css({
                                    'display': ''
                                });
                        }
                    });
            }
        });
        _this.mobileMenuLevel-=1;
    };

    _this.mobileToggleLevelAll = function ($trigger) {
        var m = /nav-level-(\d)/g.exec($trigger[0].className);
        var level=parseInt(m[1]);

        if (level>1) {
            _this.mobileCloseLevelAll();
        } else {
            _this.mobileOpenLevelAll($trigger);
        }

        $("#slide-out-innerx").scrollTop(0);
    };

    _this.openMobileSeach = function () {
        const $search = $('#header .custom-search-form');

        $search.show();
        $('body').addClass('mobile-search-open');
        _this.$searchInput.focus();

        $('#search_block_left')
            .css({
                'background-color': 'rgba(255, 255, 255, 0.0)'
            })
            .velocity('stop', true)
            .velocity({
                backgroundColorAlpha: 1
            }, {
                duration: 0
            });

        return $search;
    };


    _this.hideMobileSearch = function () {
        const $search = $('#header .custom-search-form');

        $('.search_results_wrapper').hide();
        $search.hide();
        $('#search_query_block').blur();
        $('body').removeClass('mobile-search-open');

        return $search;
    };

    _this.onSearchResultsOpen = function (input) {
        const $searchResults = $(this);

        _this.$searchResultsWrapper = $('.search_results_wrapper');

        if (_this.$searchResultsWrapper.length == 0) {
            _this.$searchResultsWrapper = $('<div class="search_results_wrapper"></div>');
        }

        if ($searchResults.closest('.search_results_wrapper').length == 0) {
            $searchResults.wrap(_this.$searchResultsWrapper);
        }

        _this.$searchResultsWrapper = $('.search_results_wrapper');

        _this.$searchResultsWrapper.data().ps = new PerfectScrollbar(_this.$searchResultsWrapper[0], {
            wheelSpeed: 1,
            wheelPropagation: false,
        });



        $(_d.body).trigger('klipsearch.beforeshow', [_this.$searchResultsWrapper]);

        if (typeof _this.$searchResultsWrapper.data('isOpen') === 'undefined' || !_this.$searchResultsWrapper.data('isOpen')) {
            _this.$searchResultsWrapper
                .css('opacity', 0)
                .velocity('slideDown', {
                    duration: _this.animationSpeed * 0.5
                })
                .velocity({
                    opacity: 1
                }, {
                    duration: _this.animationSpeed * 0.75,
                    queue: false
                })
                .data('isOpen', true);
        }
    };


    _this.onSearchResultsClose = function (input) {
        if (typeof _this.$searchResultsWrapper !== 'undefined') {
            _this.$searchResultsWrapper
                .velocity('fadeOut', {
                    duration: _this.animationSpeed * 0.5
                })
                .data('isOpen', false)
                .find('.search_results')
                .show();
        }


    };

    _this.onSearchItemFocus = function (e) {
        if (e.which == 38 || e.which == 40) {
            try {
                _this.$searchResultsWrapper.scrollTop(0);
                const $active = _this.$searchResultsWrapper.find('.ssa-active-item');
                const top = $active.position().top;
                const height = $active.outerHeight();
                _this.$searchResultsWrapper.scrollTop(top - height);
            }
            catch (err) {
                //
            }
        }
    };

    _this.positionSearchResult = function () {
        const pd = {
            position: 'fixed',
            left: _this.$searchInput.offset().left,
            top: _this.$searchInput.offset().top - $(window).scrollTop() + _this.$searchInput.innerHeight(),
            height: 350,
            width: ($(window).width() > 768 ? 350 : 320)
        };

        _this.$searchResultsWrapper
            .css('display', 'block')
            .find('.search_results')
            .css('display', 'block');

        const resultsHeight = _this.$searchResultsWrapper.find('.search_results').outerHeight(true);
        const inputHeight = $('#searchbox').outerHeight(true);


        if (_this._wWidth > 1365) {
            pd.left -= 14;
            pd.top += 10;
        }
        else if (_this._wWidth > 992) {
            pd.width = _this.$searchInput.innerWidth() + 28;
            pd.left -= 14;
            pd.top += 10;
        }
        else if (_this._wWidth <= 992) {
            pd.width = '100%';
            pd.maxHeight = $(window).innerHeight - inputHeight;

            // fall back if calculation fails
            pd.height = resultsHeight == 0 ? '100%' : resultsHeight + 16;
        }


        _this.$searchResultsWrapper
            .css(pd);
    };

    // ----------------------------- MANO PASKYRA ------------------------------------


        _this.positionLoginDropDown = function () {
            var $trigger = $('#signin-link');
            var $arrow = _this.$loginDropDown.find('.signin-dropdown-top');

            var triggerMidPoint = $trigger.position().left + ($trigger.innerWidth() / 2);
            var left = triggerMidPoint - (_this.$loginDropDown.outerWidth(true) / 2);

            var top = $trigger.innerHeight() + $trigger.position().top + 15;

            _this.$loginDropDown.css({
                'left': left-20,
                'top': top,
                'display': 'block'
            });

            _this.$loginDropDown.data().height = _this.$loginDropDown.find('.wrapper').outerHeight(true) + 20;

            while (_this.$loginDropDown.outerWidth(true) + _this.$loginDropDown.offset().left > _this.windowWidth - 15) {
                left -= 5;
                _this.$loginDropDown.css({
                    'left': left,
                });

            }
            $arrow.css({
                'left': 0
            });
            $arrow.css({
                'left': ($trigger.offset().left + ($trigger.innerWidth() / 2) - ($arrow.offset().left + 10))
            });
            _this.$loginDropDown.css({
                'display': 'none'
            });
        };


    _this.openLogindDropDown = function () {
        _this.positionLoginDropDown();
        return _this.$loginDropDown
            .css({
                display: 'block'
            })
            .velocity({
                height: _this.$loginDropDown.data().height
            }, {
                duration: _this.animationSpeed,
                complete() {
                    _this.loginDropOpen = true;
                }
            });
    };

    _this.closeLoginDropDown = function (quick = false) {
        if (!quick) {
            return _this.$loginDropDown
                .velocity({
                    height: 0
                }, {
                    duration: _this.animationSpeed,
                    complete() {
                        _this.loginDropOpen = false;
                        _this.$loginDropDown.css({
                            display: 'none'
                        });
                    }
                });
        }
        _this.loginDropOpen = false;
        return _this.$loginDropDown
            .css({
                height: 0,
                display: 'none'
            });

    };

    _this.toggleLoginDropDown = function () {
        if (_this.loginDropOpen) {
            return _this.closeLoginDropDown();
        }
        return _this.openLogindDropDown();

    };


    // --------------------------------- OTHER ------------------------------------

    _this.closeAll = function (quick = false) {
        _this.closeNavigation(quick);
        _this.closeLoginDropDown(quick);
        _this.closeMobileMenu(quick);
    };

    _this.isFit = function ($menu) {
        let fit = true;
        $menu.find('.nav-level-1').each(function () {
            const $this = $(this);
            if ($this.offset().left + $this.outerWidth(true) > _this._wWidth) {
                fit = false;
            }
        });
        return fit;
    };


    _this.moveMenuToMobile = function () {
        if (_this.$menuContent.closest('#header').length == 1) {
            //_this.$menuContent.detach().prependTo(_this.$mobileMenu.find('#slide-out-inner'));
            _this.$menuContent.detach().insertAfter(_this.$mobileMenu.find('#slide-out-inner .mobile-meniu-login-and-close '));

            _this.$menuContent.find('.nav-level-1-custom').hide();
            _this.$menuContent.find('.sub-menu-banner-right').hide();
            _this.$menuContent.find('.sub-menu-ul-left-content').removeClass('sub-menu-ul-left');

            _this.$menuContent.find('.menu-custom-link').removeClass('has-children');


            // Reset jei perkeliam atgal i mobile
            _this.$menuContent
                .find('.nav-level-1 > .menu-item-wrap')
                .hide()
                .data('level_1_open', false);

            _this.$menuContent
                .find('.nav-level-1')
                .css({
                    position: '',
                    height: '',
                    width: '',
                    top: '',
                    left: ''
                });

            _this.$menuContent
                .find('.nav-level-0').each(function () {
                $(this).find('.menu-item-wrap').css({
                    height: ''
                });
                $(this).find('.menu-item-inner-wrap').css({
                    height: ''
                });
            });

        }
    };


    _this.moveMenuToDesktop = function () {
        if (_this.$menuContent.closest('#mobile-header').length == 1) {
            _this.$menuContent.detach().appendTo(_this.$mainMenu);

            _this.$menuContent.find('.sub-menu-banner-right').show();
            _this.$menuContent.find('.nav-level-1-custom').css({'display':'inline-block'});
            _this.$menuContent.find('.sub-menu-ul-left-content').addClass('sub-menu-ul-left');
            _this.$menuContent.find('.menu-custom-link').addClass('has-children');

            // Reset jei perkeliam atgal i desktop
            _this.$menuContent.find('.menu-item-wrap:hidden').show();
            _this.$menuContent.find('.open').removeClass('open');

            $('#header .custom-search-form').css({
                height: '',
                display: ''
            });
        }
    };


    _this._responsive = function () {
        if (_this._wWidth !== window.innerWidth) {
            _this._wWidth = window.innerWidth;

            clearTimeout(_this.responsiveTimeout);
            _this.responsiveTimeout = setTimeout(() => {
                _this.responsive();
            }, 50);
        }
    };


    // -------------------------------- STICKY HEADER ----------------------------------


    const findTranslate = /\((-?.*)\)/;
    const headerStyle = _this.$headerContainer[0].style;
  //  headerStyle.top = '0px';
  //  headerStyle.transform = 'translateY(0px)';
    _this.headerOffsetTarget = 0;
    _this.distance = 0;

    _this.positionHeader = function (scrollTop = _w.pageYOffset) {
        const m = headerStyle.transform.match(findTranslate);

        _this.newTop = scrollTop < 0 ? 0 : scrollTop;

        _this.oldTop = typeof _this.oldTop === 'undefined' ? _this.newTop : _this.oldTop;

        _this.velocity = _this.oldTop - _this.newTop;


        _this.headerTop = parseFloat(m[1]);

        if (!_this.isMobile) {

            if (_this.velocity != 0) {

                _this.offset = _this.velocity + _this.headerTop;
                _this.offset = _this.offset > 0 ? 0 : (_this.offset < -_this.headerHeight ? -_this.headerHeight : _this.offset);

              //  headerStyle.transform = `translateY(${_this.offset}px)`;

                _this.headerOffsetTarget += _this.velocity;

                if (_this.headerOffsetTarget < -_this.headerHeight) {
                    _this.headerOffsetTarget = -_this.headerHeight;
                }
                else if (_this.headerOffsetTarget > 0) {
                    _this.headerOffsetTarget = 0;
                }

                if (_this.headerOffsetTarget == -_this.headerHeight) {
                        $('.search-overlay').css('display', 'none');
                        $('#search-popup-conteiner').css('display', 'none');
                }

            }

            $_w.trigger('headerposition', [{
                velocity: _this.velocity,
                pageTop: _this.newTop + _this.offset,
                pageBottom: _this.newTop + _this.offset + _this.headerHeight,
                headerHeight: _this.headerHeight,
                headerTop: _this.offset,
                scrollTop,
            }]);


        }
        else {

            if (Math.sign(_this.distance) != Math.sign(this.velocity) && Math.sign(this.velocity) != 0) {
                _this.distance = 0;
            }
            _this.distance += _this.velocity;

            let status = 0;
            let animationSpeed = 0.25;
            let speed = Math.abs(_this.velocity);
            speed = speed > 20 ? 20 : speed;
            animationSpeed = _this.mobileOutSpeedRange[0] + ((_this.mobileOutSpeedRange[1] - _this.mobileOutSpeedRange[0]) / (_this.mobileInSpeedRange[1] - _this.mobileInSpeedRange[0])) * (speed - _this.mobileInSpeedRange[0]);
            animationSpeed = animationSpeed.toFixed(2);

            if (_this.distance < -50) {
                status = -1;
            }
            else if (_this.distance > 50 || _this.newTop <= _this.headerHeight) {
                status = 1;
            }

            if (status != 0 && status != _this.lastHeaderStatus) {
                headerStyle.transform = `translateY(${status == 1 ? 0 : -_this.headerHeight}px)`;
                headerStyle.transition = `${animationSpeed}s`;
            }

            _this.lastHeaderStatus = status;

            _this.offset = status == 1 ? 0 : -_this.headerHeight;

            $_w.trigger('headerposition', [{
                velocity: _this.velocity,
                pageTop: _this.newTop + _this.offset,
                pageBottom: _this.newTop + _this.offset + _this.headerHeight,
                headerHeight: _this.headerHeight,
                headerTop: _this.offset,
                scrollTop,
            }]);
        }

        _this.oldTop = _this.newTop;
    };


    const headerSpeed = 100;
    const fps = (headerSpeed / (1000 / 60));
    _this.animateHeaderScroll = function () {
        const diff = _this.headerOffsetTarget - _this.headerTop;
        const tick = diff / fps;
        if (Math.abs(tick) > 0.001) {
            _this.headerTop += tick;
            headerStyle.transform = `translateY(${_this.headerTop}px)`;

            $_w.trigger('headerposition', [{
                velocity: _this.velocity,
                pageTop: _this.newTop + _this.headerTop,
                pageBottom: _this.newTop + _this.headerTop + _this.headerHeight,
                headerHeight: _this.headerHeight,
                headerTop: _this.headerTop,
                scrollTop: _this.newTop,
            }]);
        }
    };

    _this.getHeaderBottom = function () {
        return _this.headerTop + _this.headerHeight;
    };


        _this.loadFavoriteBlock = function () {

            $.ajax({
                type: 'POST',
                headers: {"cache-control": "no-cache"},
                url: baseUri + '?rand=' + new Date().getTime(),
                async: true,
                cache: false,
                dataType: 'html',
                data: 'controller=Auth'
                        + '&ajax=true'
                        + '&getFavoriteCount=true'
                        + '&token=' + static_token,
                success: function (html) {
                    $(".favorite-popup-load").hide();
                    $('.loading-user-favorite-block').html(html);
                },
                beforeSend: function () {
                    $(".favorite-popup-load").show();
                }
            });

        }

        _this.loadCartProductBlock = function () {

            $.ajax({
                type: 'POST',
                headers: {"cache-control": "no-cache"},
                url: baseUri + '?rand=' + new Date().getTime(),
                async: true,
                cache: false,
                dataType: 'html',
                data: 'controller=Cart'
                        + '&ajax=true'
                        + '&getCartProduct=true'
                        + '&token=' + static_token,
                success: function (html) {
                    $(".cart-popup-load").hide();
                    $('.loading-cart-product-block').html(html);
                },
                beforeSend: function () {
                    $(".cart-popup-load").show();
                }
            });

        }



    _this.init();
};

vars.navigation = new Navigation();

export default vars.navigation;
